// src/components/Sidebar.tsx
import { Drawer, List, ListItemIcon, ListItemText, Box } from "@mui/material";
import { Link } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BusinessIcon from "@mui/icons-material/Business";
import  WorkIcon  from "@mui/icons-material/Work";
import ListItemButton from "@mui/material/ListItemButton";
import UserIcon from "@mui/icons-material/SupervisedUserCircleSharp"; // Import ListItemButton

const drawerWidth = 240;

interface SidebarProps {
  open: boolean;
}

const Sidebar = ({ open }: SidebarProps) => {
  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        width: open ? drawerWidth : 60,
        flexShrink: 0,
        transition: theme => theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : 60,
          boxSizing: "border-box",
          overflowX: "hidden",
          transition: theme => theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        },
      }}
    >
      <Box sx={{ height: 64 }} /> {/* Spacer for navbar */}
      <List>
        {/* Use ListItemButton with component prop instead of ListItem with button prop */}
        <ListItemButton component={Link} to="/dashboard" sx={{ py: 1.5 }}>
          <ListItemIcon sx={{ minWidth: open ? 56 : 'auto', color: '#90caf9' }}>
            <DashboardIcon />
          </ListItemIcon>
          {open && <ListItemText primary="Dashboard" />}
        </ListItemButton>
        
      {/*   <ListItemButton component={Link} to="/companies" sx={{ py: 1.5 }}>
          <ListItemIcon sx={{ minWidth: open ? 56 : 'auto', color: '#90caf9' }}>
            <BusinessIcon />
          </ListItemIcon>
          {open && <ListItemText primary="Companies" />}
        </ListItemButton> */}
        <ListItemButton component={Link} to="/users" sx={{ py: 1.5 }}>
          <ListItemIcon sx={{ minWidth: open ? 56 : 'auto', color: '#90caf9' }}>
            < UserIcon/>
          </ListItemIcon>
          {open && <ListItemText primary="Users" />}
        </ListItemButton>
        <ListItemButton component={Link} to="/manage-job-descriptions" sx={{ py: 1.5 }}>
          <ListItemIcon sx={{ minWidth: open ? 56 : 'auto', color: '#90caf9' }}>
            < WorkIcon/>
          </ListItemIcon>
          {open && <ListItemText primary="Manage Job Descriptions" />}
        </ListItemButton>
      </List>
    </Drawer>
  );
};

export default Sidebar;